import React from 'react'
import { ButtonOLD } from '@lmc/ui-kit'
import Glyph from '../../../../../../LEGACY/Glyph'
import styles from '../../CarePlanReiviewForm.styles'
import { useTranslation } from 'react-i18next'

interface ICarePlanReviewFooter {
  handleSubmit: () => void
  handleCancel: () => void
  isSubmitting: boolean
}

export const CarePlanReviewFooter = ({
  handleSubmit,
  handleCancel,
  isSubmitting,
}: ICarePlanReviewFooter): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <div
      className="lmc-fixed-footer"
      style={{
        ...styles.footer,
      }}
    >
      <ButtonOLD
        data-testid="care-plan-edit-cancel"
        dataTestId='care-plan-cancel'
        onClick={handleCancel}
        style={styles.cancelButton}
        type="secondary"
      >
        {t('general.buttons.cancel')}
      </ButtonOLD>
      <ButtonOLD
        data-testid="care-plan-edit-save"
        dataTestId='care-plan-save'
        loading={isSubmitting}
        onClick={handleSubmit}
        type="primary"
        icon={
          <Glyph
            name="check"
            aphroditeStyles={undefined}
            className={undefined}
            color={undefined}
            component={undefined}
            size={undefined}
            style={undefined}
          />
        }
      >
        {t('general.buttons.save')}
      </ButtonOLD>
    </div>
  )
}

export default CarePlanReviewFooter
